import { SchemaWithClient } from '../types/SchemaWithClient';
import { Client } from '../services/Client';
import { NumberField } from '../components/Table/fields/NumberField';
import { TextField } from '../components/Table/fields/TextField';
import { SelectField } from '../components/Table/fields/SelectField';
import { userByRole } from './userByRole';
import { SPSelectField } from '../components/Table/fields/SPSelectField';
import { enumItems } from './enumItems';
import { SPNumberField } from '../components/Table/fields/SPNumberField';

export const serviceProviderDriver: SchemaWithClient<any> = {
  name: 'Service Provider - Driver',
  pluralName: 'Service Provider - Driver',
  tabs: [
    {
      id: 1,
      label: 'General',
      name: 'general',
    },
  ],
  columns: {
    name: {
      name: 'Name',
      fieldRenderer: TextField,
      fieldType: 'text',
      readOnly: true,
      hide: true,
    },
    service_provider: {
      name: 'Service Provider',
      fieldRenderer: SelectField.tableAdapter(enumItems.serviceProvider),
      slidePaneFieldRenderer: SPSelectField.tableAdapter(
        enumItems.serviceProvider
      ),
      switchboard: true,
      url: enumItems.serviceProvider.client.getAllPath,
      tempSchema: enumItems.serviceProvider,
      readOnly: true,
    },
    driver: {
      name: 'Driver',
      fieldRenderer: SelectField.tableAdapter(userByRole('7')),
      slidePaneFieldRenderer: SPSelectField.tableAdapter(userByRole('7')),
      switchboard: true,
      url: userByRole('7').client.getAllPath,
      tempSchema: userByRole('7'),
      required: true,
    },
    id: {
      name: 'ID',
      required: true,
      fieldRenderer: NumberField,
      slidePaneFieldRenderer: SPNumberField,
      fieldType: 'number',
      readOnly: true,
      hide: true,
    },
  },
  client: new Client('/service-provider-driver'),
};
